import { fetchUserList, fetchUserInfo } from '../../../service/api'
import TextLoop from '../../../components/TextLoop/index'
const INIT = [
  {headImage: '', userName: '张**'},
  {headImage: '', userName: '金**'},
  {headImage: '', userName: '司**'},
  {headImage: '', userName: '毛**'},
  {headImage: '', userName: '韩**'},
  {headImage: '', userName: '冷**'},
  {headImage: '', userName: '乐**'},
  {headImage: '', userName: '雷**'},
  {headImage: '', userName: '李**'},
  {headImage: '', userName: '田**'},
  {headImage: '', userName: '付**'},
  {headImage: '', userName: '张**'},
  {headImage: '', userName: '王**'},
  {headImage: '', userName: '赵**'},
  {headImage: '', userName: '吴**'},
  {headImage: '', userName: '张**'},
  {headImage: '', userName: '李**'},
  {headImage: '', userName: '周**'},
  {headImage: '', userName: '秦**'},
  {headImage: '', userName: '张**'},
]
export default {
  components: {
    TextLoop
  },
  data() {
    return {
      showNew: false,
      userInfoList: [],
      loading: false, // 是否加载完接口
      isAB: '', // 是否是从大课落地页来
    }
  },
  mounted() {
    let { link } = this.$route.query || {}
    this.isAB = link
    if(link === 'c' ) {
      this.getUserList()
      this.getUserInfo()
    }
  },
  methods: {
    async getUserInfo() {
      try{
        let {state, content} = await fetchUserInfo() || {}
          if(state === 1 && content && content.id) {
          this.showNew = !(content.id & 1) // 偶数展示
        }
      } finally {
        this.loading  = false
      }

    },
    async getUserList() {
      try {
        let {state, content={}} = await fetchUserList({
          courseId: this.courseId
        })
        if(state === 1) {
          this.userInfoList  = content && content.userInfoList || []
        }        
      } finally {
        if(this.userInfoList && this.userInfoList.length < 20) {
          this.userInfoList = [...this.userInfoList,...INIT].slice(0,20)
        }
      }

    },    
  },

}
